import { all } from "redux-saga/effects";

import { watchAppIdentityCheck } from "./appIdentityCheck";

export function* rootSaga() {
  yield all([watchAppIdentityCheck()]);
}
